import { FC, useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import { AuthenticationContext } from '@vs-online-only-app/state';
import {
  useAssociateStore,
  storeClosedAnimation,
} from '@vs-online-only-app/ui';

export const StoreClosedPlaceholder: FC = () => {
  const { user } = useContext(AuthenticationContext);
  const { formattedTimeUntilStoreOpens } = useAssociateStore(user);

  return (
    <Stack alignItems="center">
      <Lottie
        style={{ height: '200px', marginBottom: '-20px' }}
        animationData={storeClosedAnimation}
      />
      <Stack>
        <Typography variant="h6" align="center">
          Store closed.
        </Typography>
        <Typography align="center" variant="body2">
          Your store will open in{' '}
          <strong>{formattedTimeUntilStoreOpens}</strong>. <br />
          Then you can go available and start chatting with customers.
        </Typography>
      </Stack>
    </Stack>
  );
};
